import { a as r } from "./useSlots-a1aa6a84.mjs";
const o = (e, t) => r(e, t).contentRect || {};
export {
  o as u
};
